module.exports = __webpack_public_path__ + "static/media/mf.64712388.svg";